import { apiClient } from "../../lib/apiClient";

export interface AdminSession {
  id: string;
  ip: string;
  ua: string;
  created_at: string;
  last_seen_at: string;
  // True for the session backing the current device's cookie.
  is_current: boolean;
}

export async function updateName(name: string): Promise<void> {
  await apiClient.patch("/api/admin/account/me", { name });
}

export async function changePassword(
  current: string,
  newPw: string,
): Promise<void> {
  await apiClient.post("/api/admin/account/password", {
    current,
    new: newPw,
  });
}

export async function listSessions(): Promise<AdminSession[]> {
  const r = await apiClient.get<{ sessions: AdminSession[] }>(
    "/api/admin/account/sessions",
  );
  return r.data.sessions;
}

export async function deleteSession(id: string): Promise<void> {
  await apiClient.delete(
    `/api/admin/account/sessions/${encodeURIComponent(id)}`,
  );
}
